import { useEffect, useState } from 'react';
import { useWallet } from '@/hooks/wallet';
import { DEFAULT_VAL } from '@/utils/constants';
import { getAccountSumV3 } from '@/services/account';
import { useToast } from '@web3/base-hooks';

export const useAssetData = () => {
  const { walletAddresses } = useWallet();
  const { toastWarn } = useToast();

  const [data, setData] = useState({
    depositAmountSum: DEFAULT_VAL,
    yesterdayYield: DEFAULT_VAL,
    yield: DEFAULT_VAL,
  });

  const fetchData = async () => {
    const { success, result, message } = await getAccountSumV3({
      walletAddresses,
    });

    if (!success) {
      toastWarn(message);
      return;
    }

    setData({
      depositAmountSum: result.depositAmountSum,
      yesterdayYield: result.yesterdayYieldPkg?.yield ?? '0',
      yield: result.yieldPkg?.yield ?? '0',
    });
  };

  useEffect(() => {
    if (walletAddresses.length > 0) {
      fetchData();
    }
  }, [walletAddresses]);

  return {
    data,
  };
};
